
import { computed, defineComponent, ref, toRefs } from "vue";
import useToolbar from "@/composables/useToolbar";

export default defineComponent({
  name: "SelectInput",
  props: {
    selected: {
      type: String,
      required: true
    },
    label: {
      type: String,
      required: true,
      default: "label"
    },
    options: {
      type: Array,
      required: true
    },
    tabindex: {
      type: Number,
      required: false,
      default: 0
    },
    append: {
      type: Boolean,
      required: false,
      default: false
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    },
    freeze: {
      type: String
    }
  },
  setup(props, { emit }) {
    const open = ref(false);
    const { current } = useToolbar();
    const { unit, page } = toRefs(current);
    // TODO:
    // The selected name should be more elegant.. and not defined in this "genereic" component 🤷‍♂️
    const selectedName = computed(() => {
      if (props.append) {
        return props.freeze
          ? props.freeze
          : unit.value.abbreviation || unit.value.name;
      } else {
        return page.value.name;
      }
    });

    const onSelected = (option: string) => {
      open.value = false;
      emit("update:selected", option);
    };
    return { open, selectedName, onSelected };
  }
});
